import React, { useState, useEffect } from 'react'
import { Combo } from 'components'
import { fetchUrl } from 'modules/util/functions'

const TipoProductoCombo = (props) => {
	const [items, setItems] = useState([]);

	useEffect(() => {
		fetchUrl("/query/getTipoProductos", "get", {}, {
			success: (r) => {
				let items = r.data.tipoProductos.map(x => ({
					value: x.idTipoProducto,
					label: x.tipoProductoPadre ? `${x.nombre} (${x.tipoProductoPadre})` : x.nombre
				}));

				if (props.exclusions)
					items = items.filter(x => !props.exclusions.includes(x.value.toString()));

				setItems(items);
			}
		}, { block: false });
	}, [props.exclusions]);

	return (
		<Combo
			{...props}
			items={items} />
	)
}

export default TipoProductoCombo;

TipoProductoCombo.defaultProps = {
	formControl: true,
	formManaged: false
};